module.exports = __webpack_public_path__ + "7c7565bb70bc66f700ba03ac65c722fc.png";